export default interface ScrollPosition {
    height: number,
    current: number,
    top: boolean,
    bottom: boolean,
    panel: ScrollPanel
}

export enum ScrollPanel {
    Left = 'Left',
    Center= 'Center',
    Right = 'Right'
}
